<div class="dropdown">
  <select [formControl]="control" [style.width]="width" #mainSelect>
    <option *ngFor="let item of items" [ngValue]="valueName ? item[valueName] : item">
      <ng-template [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>
    </option>
  </select>
  <select class="shadow-select" #shadowSelect>
    <option #shadowOption></option>
  </select>
</div>
